import { Flex, styled } from '@shared/components';
import { memo } from 'react';

const SnackbarContainer = styled(Flex)(({ theme }) => ({
  boxSizing: 'border-box',
  maxHeight: '100%',
  position: 'fixed',
  // NOTE: We need this top: 0 to set the container to take up space at the top of the screen all the time
  // it can change if needed
  top: 0,
  zIndex: theme.zIndex.snackbar,
  height: 'auto',
  width: 'auto',
  transition: 'transform 0.3s ease',
  pointerEvents: 'none',
  flexDirection: 'column',
  left: '50%',
  transform: 'translateX(-50%)',
  [`@media (min-width: ${theme.breakpoints.values.sm}px)`]: {
    alignItems: 'center',
  },
}));
SnackbarContainer.displayName = 'SnackbarContainer';

export default memo(SnackbarContainer);
